module.exports = __webpack_public_path__ + "img/wild.86e74c02.png";